'use client'

import { HomeScreen } from "@/components/Home/index";
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useEffect } from "react";

export default function Home() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      // once: true,
    });
  }, []);
  return (
    <div>
      <HomeScreen />
    </div>
  );
}